import { render, staticRenderFns } from "./extract-artist.vue?vue&type=template&id=51940ea0"
import script from "./extract-artist.vue?vue&type=script&lang=js"
export * from "./extract-artist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports